import { Component } from '@angular/core';
import { ReportingTimesEntriesComponent } from '../employees/reporting-times-entries/reporting-times-entries';

@Component({
  selector: 'app-admin-time-entries',
  standalone: true,
  imports: [ReportingTimesEntriesComponent],
  templateUrl: './time-entries-view.html'
})
export class AdminTimeEntriesView {}
